import { TimelineLite } from 'gsap';
import { checkMail, checkPhoneNumber } from '../utils/functions';
import Loader from './Loader';

export default class Form {
	constructor(form, params = {}) {
		this.el = form;
		this.params = { ...this.getDefaultParams(), ...params };

		this.fields = form.querySelectorAll('input, textarea');
		const submitButton = form.querySelector(this.params.submitSelector);
		if (submitButton) {
			this.submitButton = new Loader(submitButton);
		}
		this.tlForm = new TimelineLite();
		this.init();
	}

	init() {
		this.addFocusListeners();
		this.el.addEventListener('submit', (ev) => {
			if (this.params.preventSubmit) {
				ev.preventDefault();
			}
			if (this.validate()) {
				if (typeof this.params.onSubmit === 'function') {
					this.params.onSubmit(ev);
				}
			}
		});
	}

	getDefaultParams() {
		return {
			submitSelector: 'input[type="button"], input[type="submit"], button',
			preventSubmit: true,
			onSubmit: () => {},
			customValidation: () => {},
		};
	}

	addFocusListeners() {
		this.fields.forEach((field) => {
			// Removes error class on focus
			field.addEventListener('focus', function (e) {
				this.classList.remove('error');
			});

			// Checks if the field is empty on blur
			field.addEventListener('blur', function (e) {
				if (this.value != '') this.classList.add('not-empty');
				else this.classList.remove('not-empty');
			});
		});
	}

	validate() {
		let emptyFields = 0;
		let errors = [];

		this.fields.forEach((field) => {
			if (field.classList.contains('required') && field.value === '') {
				emptyFields++;
				field.classList.add('error');
			}

			if (field.type === 'email' && !checkMail(field.value)) {
				errors.push(site.errors.email);
				field.classList.add('error');
			}

			if (field.type === 'tel' && !checkPhoneNumber(field.value)) {
				errors.push(site.errors.phone);
				field.classList.add('error');
			}
		});

		if (typeof this.params.customValidation === 'function') {
			const customValidationError = this.params.customValidation();
			if (customValidationError) {
				errors = Array.isArray(customValidationError)
					? [...errors, ...customValidationError]
					: [...errors, customValidationError];
			}
		}

		this.displayErrors(errors);

		return errors.length === 0 && emptyFields === 0;
	}

	displayErrors(errors) {
		let errorsContainer = this.el.querySelector('.form__errors') || this.createErrorsContainer();

		errorsContainer.innerHTML = '';

		for (let i = 0; i < errors.length; i++) {
			let error = document.createElement('p');
			error.innerHTML = errors[i];
			errorsContainer.appendChild(error);
		}

		this.tlForm.fromTo(errorsContainer, 1, { left: -100, opacity: 0 }, { left: 0, opacity: 1 });
	}

	createErrorsContainer() {
		let errorsContainer = document.createElement('div');
		errorsContainer.classList.add('form__errors');

		this.el.appendChild(errorsContainer);

		return errorsContainer;
	}

	replace(html = '') {
		const container = document.createElement('div');
		container.classList.add('form__success');
		container.innerHTML = html;
		this.el.after(container);
		this.el.parentElement.removeChild(this.el);
	}
}
